// extracted by mini-css-extract-plugin
export default {"root":"aCrYF","body":"XxLxh","input":"h1zPt","error-checkbox":"aNbjf","errorCheckbox":"aNbjf","checked":"rvtCj","icon":"OmcZ_","label":"v5XQt","error":"NSMHP"};